import shieldStarIcon from "@tabler/icons/outline/shield-star.svg";
import shieldIcon from "@tabler/icons/outline/shield.svg";
import React from "react";
import { FormattedMessage } from "react-intl";

import { HStack, Icon, Text } from "@/components/ui";
import { GroupRoles } from "@/schemas/group-member";

import type { Group } from "@/schemas";

interface GroupRelationshipProps {
  group: Group;
}

const GroupRelationship = ({ group }: GroupRelationshipProps) => {
  const isOwner = group.relationship?.role === GroupRoles.OWNER;
  const isAdmin = group.relationship?.role === GroupRoles.ADMIN;

  if (!isOwner && !isAdmin) {
    return null;
  }

  return (
    <HStack
      space={1}
      alignItems="center"
      data-testid="group-relationship"
      className="text-primary-600 dark:text-primary-400"
    >
      <Icon className="size-4" src={isOwner ? shieldStarIcon : shieldIcon} />

      <Text tag="span" weight="medium" size="sm" theme="inherit">
        {isOwner ? (
          <FormattedMessage id="group.role.owner" defaultMessage="Owner" />
        ) : (
          <FormattedMessage id="group.role.admin" defaultMessage="Admin" />
        )}
      </Text>
    </HStack>
  );
};

export default GroupRelationship;
